/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForActivityLog extends models.GovernanceConfigurationBaseForOperations {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForActivityLog.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForActivityLog>): GovernanceConfigurationBaseForActivityLog {
        let obj = Object.assign(new GovernanceConfigurationBaseForActivityLog(), model);
        GovernanceConfigurationBaseForActivityLog.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForActivityLog>): GovernanceConfigurationBaseForActivityLog {
        if (!model) return null;
        return GovernanceConfigurationBaseForActivityLog.newInstance(<GovernanceConfigurationBaseForActivityLog> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForActivityLog) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForActivityLog.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForActivityLog): boolean {
        if (models.GovernanceConfigurationBaseForOperations.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForActivityLog.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Specifies whether default configuration templates from tenant|master_account should applied or not
     */
    apply_default_activity_log_template: boolean;

}
